import { Editor } from 'tinymce';

/**
 * Add the parallax-text class to the previous siblings until image-placeholder element
 */
const addTextClassToPreviousSiblings = (
  element: HTMLElement,
  parallaxClass: string,
) => {
  let sibling = element.previousElementSibling;

  while (sibling && !sibling.classList.contains('placeholder')) {
    sibling.classList.add(parallaxClass);
    sibling = sibling.previousElementSibling;
  }
};

/**
 * Add parallax text class to all text elements that belong inside the parallax
 */
const addParallaxTextClass = (editor: Editor) => {
  // Insert the parallax cut element
  editor.insertContent(
    '<div class="parallax-cut">!---- Parallax text ends here ----!</div>',
  );

  // Create a temporary DOM element to parse the content
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = editor.getContent({ format: 'html' });

  // Reset parallax text elements if any
  const parallaxClass = 'parallax-text';
  const parallaxTextElements = tempDiv.getElementsByClassName(parallaxClass);

  // Remove parallax text class from the all elements
  document.querySelectorAll('.parallax-text').forEach(element => {
    element.classList.remove(parallaxClass);
  });
  Array.from(parallaxTextElements).forEach(parallaxText => {
    parallaxText.classList.remove(parallaxClass);
  });

  // Add parallax text class
  const parallaxCutElements = tempDiv.getElementsByClassName('parallax-cut');
  Array.from(parallaxCutElements).forEach(parallacCut => {
    addTextClassToPreviousSiblings(parallacCut as HTMLElement, parallaxClass);
  });

  // Set the updated content back to the editor
  editor.setContent(tempDiv.innerHTML);
};

/**
 * Add a custom Parallax text cut button to the toolbar
 */
export const parallax = (editor: Editor) => {
  editor.ui.registry.addButton('parallaxButton', {
    text: 'Parallax Cut',
    tooltip: 'Insert parallax text cut',
    icon: 'cut-column',
    onAction() {
      addParallaxTextClass(editor);
    },
  });
};
